import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

export default class ContainerComponent extends Component {
  @tracked submittedOnce = false;

  get isPristine() {
    if (this.submittedOnce) {
      return false;
    } else if (this.args.changeset) {
      return this.args.changeset.get('isPristine');
    } else {
      return true;
    }
  }

  saveSettings = task({ restartable: true, maxConcurrency: 1 }, async (e) => {
    e.preventDefault();
    if (this.args.changeset.get('isDirty')) {
      // yield timeout(1000);
      await this.validateAndSaveForm();
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.cancelAll();
    }
  });

  @action
  async validateAndSaveForm() {
    this.nothingChanged = false;
    await this.args.changeset.validate();
    if (!this.args.changeset.get('isValid')) return;
    this.args?.setError?.(false);

    try {
      await this.args.changeset.save();
      this.submittedOnce = true;
      if (this.args.afterSubmit) {
        this.args.afterSubmit();
      }
    } catch (err) {
      console.log(err, 'is error');
      this.args.changeset
        .get(this, 'model.errors')
        .forEach(({ attribute, message }) => {
          this.args.changeset.addError(attribute, message);
        });
      this.args?.setError?.(true);
    }
  }

  @action
  cancelAll() {
    this.saveSettings.cancelAll();
  }
}
